export default [
    {
      path: '',
      name: 'payOrder',
      meta: {
        title: '确认购买',
        activity: false
      },
      component: () => import('@/views/payPage/index.vue')
    },
    {
      path: 'pay-loading',
      name: 'pay-loading',
      meta: {
        title: '支付结果',
        activity: false
      },
      component: () => import('@/views/payPage/pay-loading/index.vue')
    },
    {
      path: 'pay-success',
      name: 'pay-success',
      meta: {
        title: '支付结果',
        activity: false
      },
      component: () => import('@/views/payPage/pay-success/index.vue')
    },
    {
      path: 'pay-error',
      name: 'pay-error',
      meta: {
        title: '支付结果',
        activity: false
      },
      component: () => import('@/views/payPage/pay-error/index.vue')
    }
  ]